// extracted by mini-css-extract-plugin
export var closeButton = "_ms-2";
export var closeButtonIcon = "_ms-3";
export var lightboxContent = "_ms-1";
export var lightboxOverlay = "_ms-0";